import React from 'react'
import ProgressBar from './ProgressBar'

function StepText({ text, step }) {
    // console.log(text);
    const { title, subtitle, fontsize } = text;
    return (
        <div className="container">
            <div className="row justify-content-center text-center">
                <div className="col-md-10">

                    {step > 4 && step <= 11 ? <ProgressBar step={step} /> : ''}
                    <h5 style={{ fontSize: fontsize ? fontsize : '2.3em' }}>{title}</h5>
                    {subtitle ?
                        <p className="subheader">{subtitle}</p>
                        : ''}

                </div>

            </div>
        </div>
    )
}

export default StepText
